import React, { useEffect } from 'react'
import { Overlay, Spinner } from './Loading.style'

const Loading = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <Overlay>
      <Spinner />
    </Overlay>
  )
}

export default Loading
